import { Injectable } from '@angular/core';
import { PlessHttp } from 'src/app/shared/http/pless-http.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessDialogServiceSub } from 'src/app/commons/kymw00/pless-dialog-service-sub';
import {
  KYMW7002Model,
  KYMW1001UserType,
} from '../kymw7002.model';

import type {
  GetSuggestionGoodsListOutputInfoCondition,
  GetSuggestionGoodsListOutputInfoSuggestionGoodsListCombination
} from '../vo/get-suggestion-goods-list-output-info-condition.model';

// リクエスト構造
export interface GetSuggestionGoodsListOutputInfoRequest {
  search: {
    SuggestionGoodsListOutputInfo: {
      condition: GetSuggestionGoodsListOutputInfoCondition;
    };
    SuggestionGoodsList: {
      combination: {
        parameter: GetSuggestionGoodsListOutputInfoSuggestionGoodsListCombination;
      }[];
    };
  };
}

// レスポンス構造
export interface GetSuggestionGoodsListOutputInfoResponse {
  /** ファイル名（ファイルパスを含む） */
  FileName: string;
}

/**
 * 提案商品一覧出力情報 取得サービス（帳票出力）
 * @export GetSuggestionGoodsListOutputInfoService
 * @class GetSuggestionGoodsListOutputInfoService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetSuggestionGoodsListOutputInfoService extends PlessJsonResponderSub<GetSuggestionGoodsListOutputInfoResponse> {
  model: KYMW7002Model;
  private requestData: GetSuggestionGoodsListOutputInfoRequest;
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetSuggestionGoodsListOutputInfoService
   */
  private getBody(): PlessRequest {
    let requestUserType = "0";
    if (this.model.userType === KYMW1001UserType.WHOLESALE) {
      requestUserType = "1";
    } else if (this.model.userType === KYMW1001UserType.PLANNING_SUPPORT) {
      requestUserType = "2";
    }

    const condition: GetSuggestionGoodsListOutputInfoCondition = {
      UserType: requestUserType,
      TotalNum: String(this.model.totalNumSuggestList),
      OrderCode: this.model.orderCode,
      MediumName: this.model.mediumName,
      MediumType: this.model.mediumType,
      FeatureName: this.model.featureName,
      Feature: this.model.feature,
    };

    const combination = [] as { parameter: GetSuggestionGoodsListOutputInfoSuggestionGoodsListCombination }[];
    for (const goods of this.model.suggestionGoodsAllList) {
      const parameter: GetSuggestionGoodsListOutputInfoSuggestionGoodsListCombination = {
        PCode: goods.PCode,
        ItemCode: goods.ItemCode,
        JanCode: goods.JanCode,
        GuideGoodsName: goods.GuideGoodsName,
        GuideStandardName: goods.GuideStandardName,
        MakerName: goods.MakerName,
        PricePattern: goods.PricePattern,
        SupplyPriceStandard: goods.SupplyPriceStandard,
        ThisTimeSupplyPriceStandard: goods.ThisTimeSupplyPriceStandard,
        CostPriceStandard: goods.CostPriceStandard,
        ThisTimeCostPriceStandard: goods.ThisTimeCostPriceStandard,
        StockNum: goods.StockNum,
        OrderUnitType: goods.OrderUnitType,
        NewUnitType: goods.NewUnitType,
        PlanNum: goods.PlanNum,
        OrderNum: goods.OrderNum,
        Remarks: goods.Remarks ?? '',
      }
      combination.push({ parameter });
    }

    this.requestData = {
      search: {
        SuggestionGoodsListOutputInfo: { condition },
        SuggestionGoodsList: { combination }
      }
    };

    return new PlessRequest(this.requestData);
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetSuggestionGoodsListOutputInfoService
   */
  execute(model: KYMW7002Model, f?: () => void): void {
    this.model = model;
    if (f) this.calbak = f;
    this.send('getSuggestionGoodsListOutputInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetSuggestionGoodsListOutputInfoService
   */
  success(data: GetSuggestionGoodsListOutputInfoResponse) {
    this.model.outputFileName = data.FileName;

    if (this.calbak) this.calbak();
  }
}
